module.exports = __webpack_public_path__ + "img/wish_03.e77a1910.png";